export default ({ request }) => ({
  stockSampleLocationListApi(data = {}) {
    return request({
      url: '/samplemanage/stockSampleLocation/list',
      method: 'post',
      data
    })
  }
})
